export const getUserDeviceLocation = async () => {
    const devicePositionRes = await new Promise((resolve) => navigator.geolocation.getCurrentPosition((positionObject) => {
        const { coords: { latitude, longitude, accuracy, altitude, heading, speed }, } = positionObject;
        const position = {
            lat: latitude,
            lng: longitude,
            elevation: altitude ?? undefined,
            heading: heading ?? undefined,
            speed: speed ?? undefined,
        };
        resolve({ err: null, data: position });
    }, (positionErr) => {
        const { PERMISSION_DENIED, POSITION_UNAVAILABLE, TIMEOUT, code, message } = positionErr;
        resolve({ err: new Error(message), data: null });
    }));
    return devicePositionRes;
};
